import createAccount from './account';
import createUser from './user';
import createUsers from './users';
import createRegion from './region';
import createEvents from "@/api/events";
import createFile from "./files"
import createUserEvents from "./userEvents"
import createSchools from "./schools"

export default http => ({
    account: createAccount(http),
    user: createUser(http),
    users: createUsers(http),
    region: createRegion(http),
    events: createEvents(http),
    files: createFile(http),
    user_events: createUserEvents(http),
    schools: createSchools(http)

})

export const VueApi = {
    /*install(app){
        app.mixin({
            beforeCreate(){
                let options = this.$options;

                if(options.api){
                    this.$api = options.api;
                }
                else if(options.parent && options.parent.$api){
                    this.$api = options.parent.$api;
                }
                console.log(this.$api)
            }
        })
    }*/

    install: (app, options) => {
        app.config.globalProperties.$api = options;
    }

}